import React from 'react';
import { useTranslations } from 'next-intl';

import { useAppSelector } from 'store';

import { blokTestConst } from 'modules/blok-test';

import { ConfirmationModal, EmptyData } from 'components';

import { LeftSide } from './left-side';
import { RightSide } from './right-side';

export const TopicTest = () => {
  const t = useTranslations();
  const currentQuestionIndex = useAppSelector(({ topicTest }) => topicTest.currentQuestionIndex);
  const testData = useAppSelector(({ topicTest }) => topicTest.test);

  return (
    <>
      <div className="m-0 mx-auto min-h-screen max-w-[1150px] p-0 lg:my-7 lg:p-4">
        <div className="flex w-full items-center justify-between bg-white px-3 py-2 lg:hidden">
          <div className="space-x-3 rounded-xl bg-indigo-600 px-4 py-1 text-sm text-white">
            <span>{t('savollar')}</span>
            <span>
              {currentQuestionIndex + 1}/{(testData?.test[0]?.questions || []).length}
            </span>
          </div>
        </div>
        {!testData ? (
          <EmptyData title={t('malumot_topilmadi')} desc={t('test_topilmadi_desc')} />
        ) : (
          <div className="mt-5 grid grid-cols-1 gap-y-3 p-4 lg:grid-cols-4 lg:gap-3">
            <LeftSide />
            <RightSide />
          </div>
        )}
      </div>

      <ConfirmationModal testType={blokTestConst.testTypes.TOPIC_TEST} ticketId={testData?.ticket_id} />
    </>
  );
};
